import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';
import SignInForm from './SignInForm';
import SignUpForm from './SignUpForm';
import ForgotPasswordForm from './ForgotPasswordForm';

// Componente estilizado para o card principal
const AuthCard = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: '#ffffff',
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: theme.shadows[3],
  maxWidth: 400,
  width: '100%',
  textAlign: 'center',
}));

// Componente estilizado para o container da página
const AuthPageContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
  backgroundColor: '#f0f2f5',
});

const AuthContainer = () => {
  const [authMode, setAuthMode] = useState('signIn');

  const renderAuthComponent = () => {
    switch (authMode) {
      case 'signIn':
        return <SignInForm onForgotPassword={() => setAuthMode('forgotPassword')} />;
      case 'signUp':
        return <SignUpForm />;
      case 'forgotPassword':
        return <ForgotPasswordForm />;
      default:
        return <SignInForm />;
    }
  };

  const getButtonText = () => {
    if (authMode === 'signIn') {
      return 'Ainda não tem uma conta? Cadastre-se';
    }
    return 'Já tem uma conta? Faça login';
  };
  
  const handleToggleAuthMode = () => {
      if (authMode === 'signIn' || authMode === 'signUp') {
        setAuthMode(authMode === 'signIn' ? 'signUp' : 'signIn');
      } else {
          setAuthMode('signIn');
      }
  };

  return (
    <AuthPageContainer>
      <AuthCard>

        {renderAuthComponent()}

        <Button
          onClick={handleToggleAuthMode}
          variant="text"
          sx={{ mt: 2 }}
        >
          {getButtonText()}
        </Button>
      </AuthCard>
    </AuthPageContainer>
  );
};

export default AuthContainer;